import { portalTemplates } from './portal-templates-i18n';
export const portalOrdersDe = {
  templates: portalTemplates.de,
  catalog: {
    templates: 'Vorlagen',
    title: 'Katalog',
    subtitle: 'Ihr Sortiment mit Ihren Preisen und der aktuellen Verfügbarkeit.',
    search: 'Artikel suchen',
    searchPlaceholder: 'Artikelnummer oder Bezeichnung …',
    favorites: 'Favoriten',
    lastOrdered: 'Zuletzt bestellt',
    all: 'Alle Artikel',
    empty: 'Keine passenden Artikel vorhanden.',
    error: 'Der Katalog konnte nicht geladen werden.',
    add: 'In den Warenkorb',
    added: 'Zum Warenkorb hinzugefügt.',
    quantity: 'Menge',
    packaging: 'Verpackungseinheit',
    baseUnit: 'Basiseinheit',
    customerDesignation: 'Ihre Bezeichnung',
    favoriteAdd: 'Als Favorit speichern',
    favoriteRemove: 'Aus Favoriten entfernen',
    customerPrice: 'Ihr Preis',
  },
  cart: {
    title: 'Warenkorb',
    subtitle: 'Preise und Verfügbarkeit werden vor dem Absenden erneut geprüft.',
    empty: 'Ihr Warenkorb ist leer.',
    remove: 'Entfernen',
    update: 'Menge aktualisieren',
    priceChanged: 'Der Preis hat sich seit dem Hinzufügen geändert.',
    unavailable: 'Die gewünschte Menge ist derzeit nicht vollständig verfügbar.',
    net: 'Netto',
    tax: 'Umsatzsteuer',
    total: 'Gesamt',
    review: 'Bestellung prüfen',
    continueShopping: 'Weiter einkaufen',
    error: 'Der Warenkorb konnte nicht geladen werden.',
  },
  checkout: {
    title: 'Bestellung prüfen',
    billingAddress: 'Rechnungsadresse',
    shippingAddress: 'Lieferadresse',
    requestedDate: 'Gewünschter Liefertermin',
    purchaseNumber: 'Ihre Bestellnummer',
    remark: 'Bemerkung',
    partialDelivery: 'Teillieferung zulassen',
    paymentTerms: 'Zahlungsziel: {{days}} Tage',
    deliveryTerms: 'Lieferkondition',
    confirm: 'Verbindlich bestellen',
    confirmed: 'Bestellung {{number}} wurde übermittelt.',
    pendingReview: 'Die Bestellung wird intern geprüft.',
    accepted: 'Der Auftrag wurde direkt bestätigt.',
    back: 'Zurück zum Warenkorb',
    priceChanged:
      'Preise oder Konditionen haben sich geändert. Bitte prüfen Sie die Zusammenfassung erneut.',
    disclaimer:
      'Die Verfügbarkeit ist eine Momentaufnahme und wird beim Absenden nochmals geprüft.',
  },
  availability: {
    AVAILABLE: 'Verfügbar',
    LOW: 'Geringer Bestand',
    OUT_OF_STOCK: 'Lieferzeit anfragen',
    NOT_MANAGED: 'Verfügbar',
    ON_REQUEST: 'Auf Anfrage',
  },
  portalOrder: {
    origin: 'Herkunft: Kundenportal',
    submittedBy: 'Bestellt von {{name}} am {{date}}',
    pending: 'Prüfung ausstehend',
    approved: 'Freigegeben',
    rejected: 'Abgelehnt',
    approve: 'Bestellung freigeben',
    reject: 'Bestellung ablehnen',
    reason: 'Begründung',
    snapshot: 'Ursprünglicher Warenkorb und Preissnapshot',
    reorder: 'Erneut bestellen',
    reordered: 'Artikel wurden in den Warenkorb übernommen.',
    reorderFailed: 'Die Artikel konnten nicht vollständig übernommen werden.',
  },
  orderSettings: {
    stockVisibility: 'Bestandsanzeige',
    exact: 'Exakte Menge',
    status: 'Nur Status',
    requireReview: 'Portalbestellungen intern prüfen',
    allowBackorders: 'Rückstände zulassen',
    allowPartialDelivery: 'Teillieferungen zulassen',
  },
};

export const portalOrdersEn = {
  templates: portalTemplates.en,
  catalog: {
    templates: 'Templates',
    title: 'Catalog',
    subtitle: 'Your assortment with your prices and current availability.',
    search: 'Search products',
    searchPlaceholder: 'Article number or name…',
    favorites: 'Favorites',
    lastOrdered: 'Recently ordered',
    all: 'All products',
    empty: 'No matching products.',
    error: 'The catalog could not be loaded.',
    add: 'Add to cart',
    added: 'Added to cart.',
    quantity: 'Quantity',
    packaging: 'Packaging unit',
    baseUnit: 'Base unit',
    customerDesignation: 'Your designation',
    favoriteAdd: 'Save as favorite',
    favoriteRemove: 'Remove from favorites',
    customerPrice: 'Your price',
  },
  cart: {
    title: 'Cart',
    subtitle: 'Prices and availability are checked again before submission.',
    empty: 'Your cart is empty.',
    remove: 'Remove',
    update: 'Update quantity',
    priceChanged: 'The price has changed since this item was added.',
    unavailable: 'The requested quantity is not currently fully available.',
    net: 'Net',
    tax: 'Tax',
    total: 'Total',
    review: 'Review order',
    continueShopping: 'Continue shopping',
    error: 'The cart could not be loaded.',
  },
  checkout: {
    title: 'Review order',
    billingAddress: 'Billing address',
    shippingAddress: 'Delivery address',
    requestedDate: 'Requested delivery date',
    purchaseNumber: 'Your purchase order number',
    remark: 'Note',
    partialDelivery: 'Allow partial delivery',
    paymentTerms: 'Payment term: {{days}} days',
    deliveryTerms: 'Delivery terms',
    confirm: 'Place binding order',
    confirmed: 'Order {{number}} was submitted.',
    pendingReview: 'The order will be reviewed internally.',
    accepted: 'The order was confirmed directly.',
    back: 'Back to cart',
    priceChanged: 'Prices or terms have changed. Please review the summary again.',
    disclaimer: 'Availability is a snapshot and is checked again on submission.',
  },
  availability: {
    AVAILABLE: 'Available',
    LOW: 'Low stock',
    OUT_OF_STOCK: 'Ask for lead time',
    NOT_MANAGED: 'Available',
    ON_REQUEST: 'On request',
  },
  portalOrder: {
    origin: 'Source: customer portal',
    submittedBy: 'Ordered by {{name}} on {{date}}',
    pending: 'Review pending',
    approved: 'Approved',
    rejected: 'Rejected',
    approve: 'Approve order',
    reject: 'Reject order',
    reason: 'Reason',
    snapshot: 'Original cart and price snapshot',
    reorder: 'Order again',
    reordered: 'The items were added to the cart.',
    reorderFailed: 'The items could not all be added.',
  },
  orderSettings: {
    stockVisibility: 'Stock display',
    exact: 'Exact quantity',
    status: 'Status only',
    requireReview: 'Review portal orders internally',
    allowBackorders: 'Allow backorders',
    allowPartialDelivery: 'Allow partial deliveries',
  },
};

export const portalOrdersTr = {
  templates: portalTemplates.tr,
  catalog: {
    templates: 'Şablonlar',
    title: 'Katalog',
    subtitle: 'Size özel ürün yelpazesi, fiyatlar ve güncel uygunluk.',
    search: 'Ürün ara',
    searchPlaceholder: 'Ürün numarası veya adı…',
    favorites: 'Favoriler',
    lastOrdered: 'Son siparişler',
    all: 'Tüm ürünler',
    empty: 'Uygun ürün bulunamadı.',
    error: 'Katalog yüklenemedi.',
    add: 'Sepete ekle',
    added: 'Sepete eklendi.',
    quantity: 'Miktar',
    packaging: 'Ambalaj birimi',
    baseUnit: 'Temel birim',
    customerDesignation: 'Sizin tanımınız',
    favoriteAdd: 'Favorilere ekle',
    favoriteRemove: 'Favorilerden çıkar',
    customerPrice: 'Fiyatınız',
  },
  cart: {
    title: 'Sepet',
    subtitle: 'Fiyatlar ve uygunluk gönderimden önce yeniden kontrol edilir.',
    empty: 'Sepetiniz boş.',
    remove: 'Kaldır',
    update: 'Miktarı güncelle',
    priceChanged: 'Ürün eklendikten sonra fiyat değişti.',
    unavailable: 'İstenen miktarın tamamı şu anda mevcut değil.',
    net: 'Net',
    tax: 'Vergi',
    total: 'Toplam',
    review: 'Siparişi kontrol et',
    continueShopping: 'Alışverişe devam et',
    error: 'Sepet yüklenemedi.',
  },
  checkout: {
    title: 'Siparişi kontrol et',
    billingAddress: 'Fatura adresi',
    shippingAddress: 'Teslimat adresi',
    requestedDate: 'İstenen teslim tarihi',
    purchaseNumber: 'Sipariş numaranız',
    remark: 'Not',
    partialDelivery: 'Kısmi teslimata izin ver',
    paymentTerms: 'Ödeme süresi: {{days}} gün',
    deliveryTerms: 'Teslimat koşulu',
    confirm: 'Bağlayıcı sipariş ver',
    confirmed: '{{number}} siparişi gönderildi.',
    pendingReview: 'Sipariş şirket içinde incelenecek.',
    accepted: 'Sipariş doğrudan onaylandı.',
    back: 'Sepete dön',
    priceChanged: 'Fiyatlar veya koşullar değişti. Özeti yeniden kontrol edin.',
    disclaimer: 'Uygunluk anlık bilgidir ve gönderimde yeniden kontrol edilir.',
  },
  availability: {
    AVAILABLE: 'Mevcut',
    LOW: 'Az stok',
    OUT_OF_STOCK: 'Teslim süresini sorun',
    NOT_MANAGED: 'Mevcut',
    ON_REQUEST: 'Talep üzerine',
  },
  portalOrder: {
    origin: 'Kaynak: müşteri portalı',
    submittedBy: '{{name}} tarafından {{date}} tarihinde sipariş edildi',
    pending: 'İnceleme bekliyor',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    approve: 'Siparişi onayla',
    reject: 'Siparişi reddet',
    reason: 'Gerekçe',
    snapshot: 'İlk sepet ve fiyat anlık görüntüsü',
    reorder: 'Tekrar sipariş et',
    reordered: 'Ürünler sepete eklendi.',
    reorderFailed: 'Ürünlerin tümü eklenemedi.',
  },
  orderSettings: {
    stockVisibility: 'Stok gösterimi',
    exact: 'Kesin miktar',
    status: 'Yalnızca durum',
    requireReview: 'Portal siparişlerini içeride incele',
    allowBackorders: 'Bekleyen siparişlere izin ver',
    allowPartialDelivery: 'Kısmi teslimata izin ver',
  },
};

export const portalOrdersFr = {
  templates: portalTemplates.fr,
  catalog: {
    templates: 'Modèles',
    title: 'Catalogue',
    subtitle: 'Votre assortiment, vos prix et la disponibilité actuelle.',
    search: 'Rechercher un article',
    searchPlaceholder: 'Référence ou désignation…',
    favorites: 'Favoris',
    lastOrdered: 'Commandés récemment',
    all: 'Tous les articles',
    empty: 'Aucun article correspondant.',
    error: 'Impossible de charger le catalogue.',
    add: 'Ajouter au panier',
    added: 'Ajouté au panier.',
    quantity: 'Quantité',
    packaging: 'Conditionnement',
    baseUnit: 'Unité de base',
    customerDesignation: 'Votre désignation',
    favoriteAdd: 'Ajouter aux favoris',
    favoriteRemove: 'Retirer des favoris',
    customerPrice: 'Votre prix',
  },
  cart: {
    title: 'Panier',
    subtitle: 'Les prix et la disponibilité sont revérifiés avant l’envoi.',
    empty: 'Votre panier est vide.',
    remove: 'Supprimer',
    update: 'Mettre à jour',
    priceChanged: 'Le prix a changé depuis l’ajout.',
    unavailable: 'La quantité demandée n’est pas entièrement disponible.',
    net: 'Net',
    tax: 'TVA',
    total: 'Total',
    review: 'Vérifier la commande',
    continueShopping: 'Continuer les achats',
    error: 'Impossible de charger le panier.',
  },
  checkout: {
    title: 'Vérifier la commande',
    billingAddress: 'Adresse de facturation',
    shippingAddress: 'Adresse de livraison',
    requestedDate: 'Date de livraison souhaitée',
    purchaseNumber: 'Votre numéro de commande',
    remark: 'Remarque',
    partialDelivery: 'Autoriser une livraison partielle',
    paymentTerms: 'Délai de paiement : {{days}} jours',
    deliveryTerms: 'Conditions de livraison',
    confirm: 'Passer la commande ferme',
    confirmed: 'La commande {{number}} a été transmise.',
    pendingReview: 'La commande sera vérifiée en interne.',
    accepted: 'La commande a été confirmée directement.',
    back: 'Retour au panier',
    priceChanged: 'Les prix ou conditions ont changé. Vérifiez à nouveau le récapitulatif.',
    disclaimer: 'La disponibilité est instantanée et sera revérifiée à l’envoi.',
  },
  availability: {
    AVAILABLE: 'Disponible',
    LOW: 'Stock faible',
    OUT_OF_STOCK: 'Délai sur demande',
    NOT_MANAGED: 'Disponible',
    ON_REQUEST: 'Sur demande',
  },
  portalOrder: {
    origin: 'Origine : portail client',
    submittedBy: 'Commandé par {{name}} le {{date}}',
    pending: 'Vérification en attente',
    approved: 'Approuvé',
    rejected: 'Refusé',
    approve: 'Approuver la commande',
    reject: 'Refuser la commande',
    reason: 'Motif',
    snapshot: 'Panier et prix d’origine',
    reorder: 'Commander à nouveau',
    reordered: 'Les articles ont été ajoutés au panier.',
    reorderFailed: 'Tous les articles n’ont pas pu être ajoutés.',
  },
  orderSettings: {
    stockVisibility: 'Affichage du stock',
    exact: 'Quantité exacte',
    status: 'Statut uniquement',
    requireReview: 'Vérifier les commandes du portail',
    allowBackorders: 'Autoriser les reliquats',
    allowPartialDelivery: 'Autoriser les livraisons partielles',
  },
};

export const portalOrdersEs = {
  templates: portalTemplates.es,
  catalog: {
    templates: 'Plantillas',
    title: 'Catálogo',
    subtitle: 'Su surtido, sus precios y la disponibilidad actual.',
    search: 'Buscar artículos',
    searchPlaceholder: 'Número o nombre del artículo…',
    favorites: 'Favoritos',
    lastOrdered: 'Pedidos recientemente',
    all: 'Todos los artículos',
    empty: 'No hay artículos coincidentes.',
    error: 'No se pudo cargar el catálogo.',
    add: 'Añadir al carrito',
    added: 'Añadido al carrito.',
    quantity: 'Cantidad',
    packaging: 'Unidad de embalaje',
    baseUnit: 'Unidad base',
    customerDesignation: 'Su denominación',
    favoriteAdd: 'Guardar como favorito',
    favoriteRemove: 'Quitar de favoritos',
    customerPrice: 'Su precio',
  },
  cart: {
    title: 'Carrito',
    subtitle: 'Los precios y la disponibilidad se comprueban de nuevo antes del envío.',
    empty: 'Su carrito está vacío.',
    remove: 'Eliminar',
    update: 'Actualizar cantidad',
    priceChanged: 'El precio ha cambiado desde que se añadió.',
    unavailable: 'La cantidad solicitada no está totalmente disponible.',
    net: 'Neto',
    tax: 'Impuesto',
    total: 'Total',
    review: 'Revisar pedido',
    continueShopping: 'Seguir comprando',
    error: 'No se pudo cargar el carrito.',
  },
  checkout: {
    title: 'Revisar pedido',
    billingAddress: 'Dirección de facturación',
    shippingAddress: 'Dirección de entrega',
    requestedDate: 'Fecha de entrega deseada',
    purchaseNumber: 'Su número de pedido',
    remark: 'Observación',
    partialDelivery: 'Permitir entrega parcial',
    paymentTerms: 'Plazo de pago: {{days}} días',
    deliveryTerms: 'Condiciones de entrega',
    confirm: 'Realizar pedido vinculante',
    confirmed: 'El pedido {{number}} se ha enviado.',
    pendingReview: 'El pedido se revisará internamente.',
    accepted: 'El pedido se confirmó directamente.',
    back: 'Volver al carrito',
    priceChanged: 'Han cambiado los precios o las condiciones. Revise de nuevo el resumen.',
    disclaimer: 'La disponibilidad es momentánea y se comprueba de nuevo al enviar.',
  },
  availability: {
    AVAILABLE: 'Disponible',
    LOW: 'Pocas existencias',
    OUT_OF_STOCK: 'Consultar plazo',
    NOT_MANAGED: 'Disponible',
    ON_REQUEST: 'Bajo consulta',
  },
  portalOrder: {
    origin: 'Origen: portal de clientes',
    submittedBy: 'Pedido por {{name}} el {{date}}',
    pending: 'Revisión pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    approve: 'Aprobar pedido',
    reject: 'Rechazar pedido',
    reason: 'Motivo',
    snapshot: 'Carrito y precios originales',
    reorder: 'Volver a pedir',
    reordered: 'Los artículos se añadieron al carrito.',
    reorderFailed: 'No se pudieron añadir todos los artículos.',
  },
  orderSettings: {
    stockVisibility: 'Visualización de existencias',
    exact: 'Cantidad exacta',
    status: 'Solo estado',
    requireReview: 'Revisar internamente los pedidos del portal',
    allowBackorders: 'Permitir pedidos pendientes',
    allowPartialDelivery: 'Permitir entregas parciales',
  },
};

export const portalOrdersRu = {
  catalog: {
    title: 'Каталог',
    subtitle: 'Ваш ассортимент, цены и текущая доступность.',
    search: 'Поиск товаров',
    searchPlaceholder: 'Артикул или название…',
    favorites: 'Избранное',
    lastOrdered: 'Заказывали недавно',
    all: 'Все товары',
    empty: 'Подходящих товаров нет.',
    error: 'Не удалось загрузить каталог.',
    add: 'В корзину',
    added: 'Добавлено в корзину.',
    quantity: 'Количество',
    packaging: 'Упаковка',
    baseUnit: 'Базовая единица',
    customerDesignation: 'Ваше наименование',
    favoriteAdd: 'Добавить в избранное',
    favoriteRemove: 'Удалить из избранного',
    customerPrice: 'Ваша цена',
  },
  cart: {
    title: 'Корзина',
    subtitle: 'Цены и наличие повторно проверяются перед отправкой.',
    empty: 'Корзина пуста.',
    remove: 'Удалить',
    update: 'Обновить количество',
    priceChanged: 'Цена изменилась после добавления.',
    unavailable: 'Запрошенное количество доступно не полностью.',
    net: 'Нетто',
    tax: 'Налог',
    total: 'Итого',
    review: 'Проверить заказ',
    continueShopping: 'Продолжить покупки',
    error: 'Не удалось загрузить корзину.',
  },
  checkout: {
    title: 'Проверить заказ',
    billingAddress: 'Платёжный адрес',
    shippingAddress: 'Адрес доставки',
    requestedDate: 'Желаемая дата доставки',
    purchaseNumber: 'Ваш номер заказа',
    remark: 'Примечание',
    partialDelivery: 'Разрешить частичную поставку',
    paymentTerms: 'Срок оплаты: {{days}} дн.',
    deliveryTerms: 'Условия поставки',
    confirm: 'Отправить обязательный заказ',
    confirmed: 'Заказ {{number}} отправлен.',
    pendingReview: 'Заказ пройдёт внутреннюю проверку.',
    accepted: 'Заказ подтверждён сразу.',
    back: 'Вернуться в корзину',
    priceChanged: 'Цены или условия изменились. Проверьте итог ещё раз.',
    disclaimer: 'Наличие указано на текущий момент и проверяется при отправке.',
  },
  availability: {
    AVAILABLE: 'В наличии',
    LOW: 'Мало на складе',
    OUT_OF_STOCK: 'Уточнить срок',
    NOT_MANAGED: 'Доступно',
    ON_REQUEST: 'По запросу',
  },
  portalOrder: {
    origin: 'Источник: клиентский портал',
    submittedBy: 'Заказ оформил(а) {{name}}, {{date}}',
    pending: 'Ожидает проверки',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    approve: 'Одобрить заказ',
    reject: 'Отклонить заказ',
    reason: 'Причина',
    snapshot: 'Исходная корзина и цены',
    reorder: 'Заказать снова',
    reordered: 'Товары добавлены в корзину.',
    reorderFailed: 'Не все товары удалось добавить.',
  },
  orderSettings: {
    stockVisibility: 'Отображение запаса',
    exact: 'Точное количество',
    status: 'Только статус',
    requireReview: 'Проверять заказы портала',
    allowBackorders: 'Разрешить отложенные позиции',
    allowPartialDelivery: 'Разрешить частичные поставки',
  },
};
